export const initSetBookingType = () => {
  const modalTriggers = document.querySelectorAll('[data-open-modal="modal-booking"]');
  const modalForm = document.querySelector('[data-modal="modal-booking"] form');
  if (!modalTriggers.length || !modalForm) {
    return;
  }
  modalTriggers.forEach((btn) => {
    const triggerType = btn.dataset.bookingType;
    if (!triggerType) {
      return;
    }
    btn.addEventListener('click', () => {
      modalForm.dataset.formType = triggerType;
    });
  });
};
